var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var SearchDriveIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '22' : _b, _c = _a.height, height = _c === void 0 ? '20' : _c;
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 22 20", fill: "currentColor", className: "inline-block" }, { children: _jsx("path", { d: "M13.5 0C11 0 9 2 9 4.5C9 7 11 9 13.5 9C14.4 9 15.2 8.7 15.9 8.3L19 11.4L20.4 10L17.3 6.9C17.7 6.2 18 5.4 18 4.5C18 2 16 0 13.5 0ZM2 2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V13L16 11V18H2V4H7.03C7.09 3.3 7.26 2.65 7.5 2H2ZM13.5 2C14.9 2 16 3.1 16 4.5C16 5.9 14.9 7 13.5 7C12.1 7 11 5.9 11 4.5C11 3.1 12.1 2 13.5 2Z", fill: "currentColor" }) })));
};
export default SearchDriveIcon;
